import MetricInfoIcon from "../ui/MetricInfoIcon";
import type { MetricSample } from "../../hooks/useMetricSamples";

interface CompactMetricCardProps {
  label: string;
  value: string;
  sub?: string;
  metricKey?: string;
  getSamples?: (key: string) => MetricSample[];
}

export default function CompactMetricCard({
  label,
  value,
  sub,
  metricKey,
  getSamples,
}: CompactMetricCardProps) {
  return (
    <div className="liquid-glass anim-lift px-4 py-3.5">
      <div className="token-9 text-glass-tertiary uppercase mb-1">
        {metricKey && getSamples ? (
          <MetricInfoIcon metricKey={metricKey} getSamples={getSamples}>
            {label}
          </MetricInfoIcon>
        ) : (
          label
        )}
      </div>
      <div className="token-15 text-glass metric-value">{value}</div>
      {sub && <div className="token-9 text-glass-muted mt-1">{sub}</div>}
    </div>
  );
}
